import {analyticsLogEvent} from '../api'

/** Express payment method that started the fast checkout. Maps to `eventLabel`. */
type ExpressPaymentType = 'Paypal' | 'ApplePay'

interface Parameters {
    /** Provenance of the fast checkout (e.g. 'minicart', 'pdp', 'confirm_layer_add_to_cart'). Maps to `accessType`. */
    accessType: string
    /** Express payment method. Defaults to 'Paypal' for backward compatibility. */
    paymentType?: ExpressPaymentType
}

/**
 * @name analyticsExpressPaymentStart
 *
 * @event
 *
 * @description
 * Tracks the start of a fast (express) checkout.
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.6.1.
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'checkout', eventAction: 'fast', eventLabel: 'Paypal'|'ApplePay', accessType: '[PROVENANCE]' }`
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.accessType - Provenance of the fast checkout, mapped to `accessType`.
 * @param {ExpressPaymentType} [params.paymentType] - Express payment method, mapped to `eventLabel`. Defaults to 'Paypal'.
 */
export function analyticsExpressPaymentStart({accessType, paymentType = 'Paypal'}: Parameters) {
    const eventDetails = {
        eventCategory: 'checkout',
        eventAction: 'fast',
        eventLabel: paymentType,
        accessType: accessType,
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 * @deprecated Use {@link analyticsExpressPaymentStart} instead. Kept as an alias for existing PayPal call sites.
 */
export const analyticsPaypalExpressStart = analyticsExpressPaymentStart
